import {Injectable} from '@angular/core';
import {BaseService} from "./base.service";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {User} from "../modules/web/models/user";
import {AuthService} from "./auth.service";
import {Customer} from "../modules/web/models/CustomerInfo/Customer";

@Injectable({
    providedIn: 'root'
})
export class MagentoCustomerService extends BaseService {

    constructor(private httpClient: HttpClient, private authService: AuthService) {
        super();
    }

    info: User;


    addUserInfo(user: User) {
        this.info = user;
    }

    getUserInfo() {
        return this.info;
    }

    public getCustomerInfo() {

        let serviceURL = this.baseAPI + "customers/me"
        return this.httpClient.get<any>(serviceURL, this.authService.getHttpOptions());

    }

    public updateCustomerData(customer: Customer) {


        let serviceURL = this.baseAPI + "customers/me"

        let params = {

            "customer": {

                "email": customer.email,
                "firstname": customer.firstname,
                "lastname": customer.lastname,
                "website_id": customer.websiteId,
                "addresses": customer.addresses
            }
        }
        return this.httpClient.put<any>(serviceURL, params, this.authService.getHttpOptions());

    }

    public signUp(customer: User) {


        return this.httpClient.post<any>(this.baseAPI + "customers", customer, this.authService.getHttpOptions());

    }

    public isEmailAvailable(email): any {
        return this.httpClient.post<any>(this.baseAPI +'adham/customer/check', {"email": email}, this.authService.getHttpOptions());

    }


}
